import {batchDecryptMessage} from '@/api/product/productManage'

/**
 * 根据对象自动检测加密字段并批量解密
 * @param {Object} obj - 包含加密字段的对象
 * @returns {Promise<Object>} 解密后的对象
 */
export async function decryptMessageByObject(obj = {}) {
	try {
		if (!obj || typeof obj !== 'object') {
			return obj
		}
		// 收集需要解密的字段信息
		const decryptItems = []
		// 循环对象，查找包含 "Crypt" 的 key
		Object.keys(obj).forEach((key) => {
			if (key.endsWith('Crypt') || key.includes('Crypt')) {
				// 提取原始字段名，比如 phoneCrypt -> phone
				const originalProp = key.replace('Crypt', '')
				//不需要decryptTypeDic，type直接赋值 0
				if (obj[key]) {
					// 生成解密请求对象
					decryptItems.push({
						message: obj[key],
						type: 0,
						key: originalProp,
					})
				}
			}
		})
		// 如果没有找到需要解密的字段，返回原对象
		if (decryptItems.length === 0) {
			return obj
		}
		console.log('🔐 发现需要解密的字段:', decryptItems.length, '个')
		// 调用批量解密接口
		const response = await batchDecryptMessage(decryptItems)
		const {data = []} = response.data || {}
		if (!Array.isArray(data) || data.length === 0) {
			console.warn('⚠️ 解密接口返回数据为空')
			return obj
		}
		// 创建解密后的对象副本
		const decryptedObj = {...obj}
		decryptItems.forEach(({key, message}) => {
			let decryptResult = data.find(({message: item2Message}) => item2Message === message)
			if (decryptResult) {
				decryptedObj[key] = decryptResult.decryptMessage
			}
		})
		console.log('🎯 批量解密完成，共处理', data.length, '个字段')
		return decryptedObj
	} catch (error) {
		console.error('❌ 批量解密失败:', error)
		return obj // 解密失败时返回原对象
	}
}

/**
 * 批量解密dataList数组中的加密字段
 * @param {Array} dataList - 需要解密的结算账户数组
 */
export async function decryptMessageByArray(dataList = []) {
	try {
		if (dataList.length === 0) {
			console.log('🔐 dataList为空，无需解密')
			return dataList
		}
		console.log('🔐 开始批量解密dataList，共', dataList.length, '个账户')
		// 第一步：循环dataList，重新创建一个对象，对象的参数key为原来参数+ index
		const decryptObj = {}
		dataList.forEach((accountItem, index) => {
			Object.keys(accountItem).forEach((key) => {
				// 为每个参数key添加index后缀
				const newKey = `${key}${index}`
				decryptObj[newKey] = accountItem[key]
			})
		})
		console.log('🔐 构建解密对象完成，包含字段：', Object.keys(decryptObj).length, '个')
		// 第二步：调用解密decryptMessageByObject
		const decryptedData = (await decryptMessageByObject(decryptObj)) || {}
		console.log('🔐 批量解密完成', decryptedData)
		// 第三步：再次循环dataList，把得到的结果，再重新赋值给原来的参数，不加index
		dataList.forEach((accountItem, index) => {
			Object.keys(accountItem).forEach((key) => {
				const indexedKey = `${key}${index}`
				// 如果解密结果中存在这个带索引的key，则更新原对象
				if (decryptedData.hasOwnProperty(indexedKey)) {
					accountItem[key] = decryptedData[indexedKey]
				}
			})
		})
		console.log('🎯 dataList批量解密完成，已更新', dataList)
		return dataList
	} catch (error) {
		console.error('❌ dataList批量解密失败:', error)
		// 解密失败时不影响原数据
		return dataList
	}
}
